<template>
  <aside class="app-rail bg-primary-lighten-5">
    <nav>
      <CalendarPageButtons
        v-if="!swipeAnim && !hideButtons"
        @filter="showFilters = !showFilters"
        @audio="openAudioFromRail"
      />

      <v-list
        class="bg-transparent"
      >
        <v-list-item
          class="bg-transparent px-0 text-center my-2 rounded-lg"
          :to="$routeTo(ROUTES.CALENDAR)"
          plain
        >
          <v-btn
            :variant="$route?.name.startsWith(ROUTES.CALENDAR) ? 'flat' : 'text'"
            size="small"
            class="rounded-xl mb-1"
            :class="{'bg-primary text-on-primary': $route.name === ROUTES.CALENDAR || $route.name.startsWith('event')}"
          >
            <v-icon>
              calendar_month
            </v-icon>
          </v-btn>
          <v-list-item-title
            class="text-size-minus-2"
          >
            Calendar
          </v-list-item-title>
        </v-list-item>
        
        <v-list-item
          class="bg-transparent px-0 text-center my-2 rounded-lg"
          :to="$routeTo(ROUTES.TODOS)"
          plain
        >
          <v-btn
            :variant="$route?.name.startsWith(ROUTES.TODOS) ? 'flat' : 'text'"
            size="small"
            class="rounded-xl mb-1"
            :class="{'bg-primary text-on-primary': $route.name.startsWith(ROUTES.TODOS)}"
          >
            <v-icon>
              checklist
            </v-icon>
          </v-btn>
          <v-list-item-title
            class="text-size-minus-2"
          >
            Lists
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          class="bg-transparent px-0 text-center my-2 rounded-lg"
          :to="$routeTo(ROUTES.ANNOTATIONS)"
          plain
        >
          <v-btn
            :variant="$route?.name === ROUTES.ANNOTATIONS ? 'flat' : 'text'"
            size="small"
            class="rounded-xl mb-1"
            :class="{'bg-primary text-on-primary': $route.name === ROUTES.ANNOTATIONS}"
          >
            <v-icon>
              draw
            </v-icon>
          </v-btn>
          <v-list-item-title
            class="text-size-minus-2"
          >
            Notes
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          class="bg-transparent px-0 text-center my-2 rounded-lg"
          :to="$routeTo(ROUTES.SETTINGS)"
          plain
        >
          <v-btn
            :variant="$route?.name === ROUTES.SETTINGS ? 'flat' : 'text'"
            size="small"
            class="rounded-xl mb-1"
            :class="{'bg-primary text-on-primary': $route.name === ROUTES.SETTINGS}"
          >
            <v-icon>
              settings
            </v-icon>
          </v-btn>
          <v-list-item-title
            class="text-size-minus-2"
          >
            Settings
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </nav>
  </aside>
</template>
<script lang="ts">
import {defineComponent} from 'vue'
import CalendarPageButtons from '@/components/CalendarPageButtons.vue'

export default defineComponent({
  name: 'AppRail',
  components: {
    CalendarPageButtons,
  },
  props: {
    hideButtons: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showFilters: false,
      showAudio: false,
      swipeAnim: ''
    }
  },
  methods: {
    openAudioFromRail() {
      const route = this.$routeTo(this.ROUTES.CALENDAR, {}, { 'audio-note': 1 })
      this.$router.push(route)
    }
  }
})
</script>
<style lang="scss">
.app-rail {
  bottom: 0;
  left: 0;
  padding: 1rem;
  position: fixed;
  top: 0;
  width: 6rem;
  z-index: 999;

  .v-list-item--variant-text {
    .v-list-item__overlay,
    .v-list-item__underlay {
      display: none !important;
    }

    &:hover {
      .v-btn__overlay {
        opacity: calc(var(--v-hover-opacity) * var(--v-theme-overlay-multiplier));
      }
    }
  }
}
</style>